module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_SL-37419f0547a065e2f91f46f1c4f0fa08.svg";